import Swal from 'sweetalert2';
import { formatDateToDDMMYYYY, validateExpenseFields } from './expenseUtils';

export const handleAmountChange = (value) => {
  const numericValue = parseFloat(value.replace(/[^0-9.,]/g, '').replace(',', '.'));
  return isNaN(numericValue) ? '' : numericValue.toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const handleDateChange = (date) => {
  return formatDateToDDMMYYYY(date);
};

export const validateForm = (amount, date) => {
  const parsedAmount = parseFloat(amount.replace(/[^0-9.,]/g, '').replace(',', '.'));

  if (isNaN(parsedAmount) || parsedAmount <= 0) {
    Swal.fire({
      icon: 'error',
      title: 'Erreur',
      text: 'Le montant doit être un nombre positif',
      confirmButtonText: 'OK'
    });
    return false;
  }

  if (!date) {
    Swal.fire({
      icon: 'error',
      title: 'Erreur',
      text: 'La date est requise',
      confirmButtonText: 'OK'
    });
    return false;
  }

  const formattedDate = formatDateToDDMMYYYY(date);
  const validationError = validateExpenseFields(parsedAmount, formattedDate);
  
  if (validationError) {
    Swal.fire({
      icon: 'error',
      title: 'Erreur',
      text: validationError,
      confirmButtonText: 'OK'
    });
    return false;
  }

  return { parsedAmount, formattedDate };
}; 